export const ONE_MILLION = 1000000
